<template>
    <div>
        <button type="button" :disabled="saving" class="btn btn-sm btn-success" @click="saveNewRating">Save</button>
        <button type="button" :disabled="saving" class="btn btn-sm btn-secondary" @click="cancelNewRating">Cancel</button>
        <hr>
        <div class="row">
            <div class="col-md-6">
                <b-form-group label="Jobsite" :label-class="errors.JobsiteId ? 'text-danger' : ''">
                    <jobsite-select :selectedValues="JobsiteValues" @vselected="onJobSiteSelectUpdate" :hasError="errors.JobsiteId ? true : false"></jobsite-select>
                     <span v-if="errors.JobsiteId" class="text-danger">
                        <span v-for="error in errors.JobsiteId">{{ error }}</span>
                    </span>
                </b-form-group>
                <template v-for="(question,index) in rating.ratings">
                    <b-form-group class="form-inline" :label-class="errors[`ratings.${index}.rating`] ? 'text-danger' : ''" :label="question.question" >
                        <b-form-input :class="{'is-invalid': errors[`ratings.${index}.rating`]}" style="width: 70px;" v-model="question.rating" type="number" autocomplete="off" min="1" :max="question.max_rating" /> / {{ question.max_rating }}
                        <span v-if="errors[`ratings.${index}.rating`]" class="text-danger">
                            <br>
                            <span v-for="error in errors[`ratings.${index}.rating`]">{{ error }}</span>
                        </span>
                    </b-form-group>
                </template>
                <b-form-group label="Recommended for future use?" :label-class="errors.future_use ? 'text-danger' : ''">
                    <b-form-radio-group v-model="rating.future_use" name="future_use" plain>
                        <b-form-radio value="1">Yes</b-form-radio>
                        <b-form-radio value="0">No</b-form-radio>
                    </b-form-radio-group>
                    <span v-if="errors.future_use" class="text-danger">
                        <span v-for="error in errors.future_use">{{ error }}</span>
                    </span>
                </b-form-group>
                <b-form-group>
                    <label :class="errors.comments ? 'text-danger' : ''">Comments <span v-if="rating.future_use == '0'"><i class="fa fa-asterisk text-danger"></i></span></label>
                    <b-textarea v-model="rating.comments" :class="{'is-invalid': errors.comments}" placeholder="Enter Any Comments, Concerns, or Recommendations" />
                    <span v-if="errors.comments" class="text-danger">
                        <span v-for="error in errors.comments">{{ error }}</span>
                    </span>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <span style="white-space: pre-line;">{{ ratingLegend }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: {
            initialRating: {
                type: Object,
            },
            ratingQuestions: {
                type: Array,
            },
            ratingLegend: {
                type: String,
                default: '',
            },
        },

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                saving: false,
                subcontractor_id: this.$route.params.id,
                errors: {},
                rating: {ratings: []},
            }
        },

        computed: {
            JobsiteValues(){
                //check for null
                if(!this.rating.JobsiteId)
                {
                    //Check the store
                    if(this.$store.state.user.jobsite)
                    {
                        var jobsite = this.$store.state.user.jobsite;

                        //Set the HSE jobsite
                        this.rating.JobsiteId = jobsite.JobsiteId;

                        //Send it
                        return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
                    }

                    return null;
                }

                return {JobsiteId: this.rating.JobsiteId, JobsiteNumber: this.rating.JobsiteNumber, JobsiteName: this.rating.JobsiteName};
            },
        },

        methods: {
            saveNewRating: function() {
                this.saving = true;

                this.$http
                    .post(`subcontractors/rate/${this.subcontractor_id}`, this.rating)
                    .then(response => {
                        this.$toastr.success('Evaluation saved');
                        this.$emit('saveNewRating', response.data);
                        this.errors = {};
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data;
                        }
                    })
                    .then(response => {
                        this.saving = false;
                    });
            },

            cancelNewRating: function() {
                this.$emit('cancelNewRating');
            },

            onJobSiteSelectUpdate (jobsite) {
                //Check for null
                if(jobsite == null)
                {
                    //Stop
                    this.rating.JobsiteId = null;
                    this.rating.JobsiteName = null;
                    this.rating.JobsiteNumber = null;
                    return;
                }

                //Send the value
                this.rating.JobsiteId = jobsite.JobsiteId;
                this.rating.JobsiteName = jobsite.JobsiteName;
                this.rating.JobsiteNumber = jobsite.JobsiteNumber;
            },

            setRating(rating)
            {
                this.rating = rating;
            }
        },

        mounted() {
            if (this.initialRating != null)
            {
                this.rating.ratings = JSON.parse(JSON.stringify(this.ratingQuestions));
            }
        }
    }
</script>

<style>
    .no-form-group-margin .form-group {
        margin-bottom: 0;
    }
</style>
